window.themeQuickAddProductHtmlCache = window.themeQuickAddProductHtmlCache || new Map();

function normalizeCompleteTheLookProductUrl(href) {
  if (!href || !href.includes('/products/')) return null;
  if (href.startsWith('/')) return new URL(href, window.location.origin).href;
  try {
    return new URL(href).href;
  } catch {
    return null;
  }
}

function collectCompleteTheLookProductUrls(section) {
  const urls = new Set();
  section.querySelectorAll('.complete-the-look__card a[href*="/products/"]').forEach((a) => {
    const u = normalizeCompleteTheLookProductUrl(a.getAttribute('href') || a.getAttribute('data-base-url'));
    if (u) urls.add(u);
  });
  return [...urls];
}

/** Descarga las páginas de producto del slider en idle y llena la misma caché que quick-add-modal. */
function prefetchCompleteTheLookProductPages(section) {
  const urls = collectCompleteTheLookProductUrls(section);
  if (!urls.length) return;

  const cache = window.themeQuickAddProductHtmlCache;
  const prefetchOne = (url) => {
    if (cache.has(url)) return;
    fetch(url, { credentials: 'same-origin' })
      .then((r) => r.text())
      .then((text) => cache.set(url, text))
      .catch(() => {});
  };

  const run = () => {
    urls.forEach((url, i) => {
      window.setTimeout(() => prefetchOne(url), i * 100);
    });
  };

  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(run, { timeout: 2500 });
  } else {
    window.setTimeout(run, 300);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const swiperCompleteTheLook = new Swiper('.swiper-complete-the-look', {
    slidesPerView: 1.4,
    spaceBetween: 10,
    preventClicks: true,
    preventClicksPropagation: true,
    threshold: 8,
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: '.complete-the-look__nav .swiper-button-next',
      prevEl: '.complete-the-look__nav .swiper-button-prev',
    },
    scrollbar: {
      el: '.complete-the-look__nav .swiper-scrollbar',
      draggable: true,
      dragSize: 237,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 8,
      },
    },
  });

  const section = document.querySelector('.complete-the-look');
  const drawer = document.getElementById('CompleteTheLookDrawer');
  const opener = document.getElementById('complete-the-look-drawer-opener');

  if (section) {
    prefetchCompleteTheLookProductPages(section);
  }

  if (!drawer || !opener) return;

  /** Evita abrir el modal cuando el gesto era scroll/drag del Swiper (el click fantasma sobre el enlace). */
  const MOVE_PX = 14;
  let pointerTrack = { active: false, id: null, x: 0, y: 0, dragged: false };
  let blockNextProductLinkClick = false;

  const onPointerMove = (e) => {
    if (!pointerTrack.active || e.pointerId !== pointerTrack.id) return;
    const dx = Math.abs(e.clientX - pointerTrack.x);
    const dy = Math.abs(e.clientY - pointerTrack.y);
    if (dx > MOVE_PX || dy > MOVE_PX) pointerTrack.dragged = true;
  };

  const endPointerTrack = (e) => {
    if (!pointerTrack.active || e.pointerId !== pointerTrack.id) return;
    document.removeEventListener('pointermove', onPointerMove);
    document.removeEventListener('pointerup', endPointerTrack);
    document.removeEventListener('pointercancel', endPointerTrack);
    pointerTrack.active = false;
    if (pointerTrack.dragged) blockNextProductLinkClick = true;
    pointerTrack.dragged = false;
    pointerTrack.id = null;
  };

  if (section) {
    section.addEventListener(
      'pointerdown',
      (e) => {
        const card = e.target.closest('.complete-the-look__card');
        if (!card || !section.contains(card)) return;
        pointerTrack = {
          active: true,
          id: e.pointerId,
          x: e.clientX,
          y: e.clientY,
          dragged: false,
        };
        document.addEventListener('pointermove', onPointerMove);
        document.addEventListener('pointerup', endPointerTrack);
        document.addEventListener('pointercancel', endPointerTrack);
      },
      true,
    );
  }

  document.addEventListener(
    'click',
    (e) => {
      const card = e.target.closest('.complete-the-look__card');
      if (!card) return;
      if (!card.closest('.complete-the-look')) return;

      if (blockNextProductLinkClick) {
        blockNextProductLinkClick = false;
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      const link = e.target.closest('a[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
      if (!link) return;

      e.preventDefault();
      e.stopPropagation();
      let productUrl = link.getAttribute('href') || link.getAttribute('data-base-url');
      if (!productUrl) return;

      const normalized = normalizeCompleteTheLookProductUrl(productUrl);
      if (!normalized) return;
      productUrl = normalized;

      opener.setAttribute('data-product-url', productUrl);
      drawer.show(opener);
    },
    true,
  );
});
